import {ILayerState} from "../store/types";

export function getLayerName (layerId: string, layerState: ILayerState) {
    try {
        return layerState[layerId].name
    } catch (e) {
        console.warn(e);
    }
    return 'No Name';
}